<template>

    <Head>
        <title>Desarrollo integral de la familia</title>
    </Head>
    <div class="hero-img-overlay hero-lila" style="background-image: url(/img/hero-dif.png);">
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-lg-7">
                    <h1 class="hero-encabezado">Trámites y Servicios DIF</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="contenido-wrapper">
        <div class="bloque-general bloque-info-img">
            <div class="container">
                <div class="row flex-md-row-reverse">
                    <div class="col-md-7">
                        <h2 class="bloque-subencabezado">Tú eres el centro de nuestras acciones</h2>
                        <div class="bloque-descripcion">
                            <p>En el DIF Santiago te apoyamos con trámites, servicios y programas que fomentan el desarrollo integral de las familias santiaguenses y de los grupos en situación de vulnerabilidad, en coordinación con instituciones públicas, privadas y la sociedad civil.</p>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <div class="bloque-info-img__img">
                            <img loading="lazy" width="278" height="245" src="/img/hexa-dif-tramites.jpg" alt="DIF">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bloque-general bloque-slider-servicios">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="slider-tramites-servicios__encabezado">Conoce diferentes Trámites y Servicios del DIF Santiago</div>
                        <div class="slider-tramites-servicios row">

                            <div v-for="(item, i) in servicios" :key="i"
                                class="tramite-servicio-item col-lg-3 col-md-4 col-sm-12">
                                <img loading="lazy" width="63" height="55" class="tramite-servicio-item__icono"
                                    src="/img/icono-hexagono-lila.svg" alt="" />
                                <Link :href="`/servicio/`+item.slug" class="tramite-servicio-item__nombre">{{ item.nombre }}</Link>
                                <div class="tramite-servicio-item__info_corta">{{ item.descripcion_corta }}</div>
                                <Link :href="`/servicio/`+item.slug" class="boton-terciario boton-flecha">Ver más</Link>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import NoResults from "../../Shared/Utils/NoResults.vue";
import { Link } from '@inertiajs/inertia-vue3'

export default {
    components: {
        NoResults, Link
    },
    props: {
        servicios: Object,
    },
}
</script>
<style scoped>
.tramite-servicio-item {
    margin-right: 0 !important;
    margin-bottom: 30px;
}

.fi {
    margin-right: 5px;
    color: #b1b3db;
}
</style>
